import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { AreaSituacaoMultiselectComponent } from './multiselect';
import { AreaSituacaoPipe } from './pipes';
import { AreaSituacaoBadgeComponent } from './badge';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        AreaSituacaoMultiselectComponent,
        AreaSituacaoBadgeComponent,

        // Pipes
        AreaSituacaoPipe
    ],
    exports: [
        AreaSituacaoMultiselectComponent,
        AreaSituacaoBadgeComponent,

        // Pipes
        AreaSituacaoPipe
    ],
    providers: [
        // Pipes
        AreaSituacaoPipe
    ]
})
export class AreaSituacaoModule { }
